module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "settings includes-header"
  }, [_c('header', {
    staticClass: "page-header settings-header"
  }, [(!_vm.inModal) ? _c('router-link', {
    staticClass: "back tag button-timid left",
    attrs: {
      "to": {
        name: 'root'
      }
    }
  }, [_vm._v("x Sluiten")]) : _vm._e(), _c('h1', [_vm._v("Instellingen")]), _c('p', [_vm._v("Hier kun je jouw gegevens aanpassen.")])], 1), _c('div', {
    staticClass: "settings-links tag"
  }, [_c('a', {
    class: {
      'is-active': _vm.personalActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPersonal($event)
      }
    }
  }, [_vm._v("Naam")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.emailActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewEmail($event)
      }
    }
  }, [_vm._v("E-mail")]), _vm._v(" |\n        "), _c('a', {
    class: {
      'is-active': _vm.passwordActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewPassword($event)
      }
    }
  }, [_vm._v("Wachtwoord")]), (_vm.isGroupAvailable) ? [_vm._v("| "), _c('a', {
    class: {
      'is-active': _vm.groupActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewGroup($event)
      }
    }
  }, [_vm._v("Klas")])] : _vm._e()], 2), (!_vm.inModal) ? _c('router-view', {
    staticClass: "page-content",
    attrs: {
      "user": _vm.user
    }
  }) : _c(_vm.view, {
    tag: "component",
    staticClass: "settings-modal-content",
    attrs: {
      "user": _vm.user
    },
    on: {
      "done": _vm.done
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09da70ee","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/settings/Settings.vue
// module id = EzKL
// module chunks = 0 1